import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { Rehearsal } from '../rehearsal';
import { RehearsalService } from '../rehearsal.service';
import { usePrivilege } from '../../auth/privilege-hooks';
import { Privileges } from '../../../models/privileges';

@Component({
    selector: 'app-rehearsal-details-modal',
    templateUrl: './rehearsal-details-modal.component.html',
    styleUrls: ['./rehearsal-details-modal.component.scss'],
    standalone: false
})
export class RehearsalDetailsModalComponent implements OnInit{

  @Input() public rehearsalId: number;

  protected rehearsal: Rehearsal | null = null;
  protected isLoading: boolean = true;
  /** Signal-reactive; re-evaluates when the user signal loads. */
  protected canEditRehearsal = usePrivilege(Privileges.RehearsalEdit);
  protected isNavigating: boolean = false;

  private modalCtrl: ModalController = inject(ModalController);
  private rehearsalService: RehearsalService = inject(RehearsalService);
  private navController: NavController = inject(NavController);

  public async ngOnInit(): Promise<void> {
    await this.loadRehearsal();
  }

  protected closeModal(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  protected async navigateToEdit(): Promise<void> {
    if (!this.rehearsal?.performance?.id || this.isNavigating) {
      return;
    }

    try {
      this.isNavigating = true;
      const tokenResponse = await this.rehearsalService.requestExternalRehearsalUrlForPerformance(this.rehearsal.performance.id);
      const token = tokenResponse?.token;

      if (token) {
        await this.modalCtrl.dismiss(null, 'navigate');
        await this.navController.navigateRoot(['/rehearsal', 'external', token]);
      }
    } catch (e) {
      console.error('Error getting rehearsal token:', e);
    } finally {
      this.isNavigating = false;
    }
  }

  private async loadRehearsal(): Promise<void> {
    try {
      this.isLoading = true;
      this.rehearsal = await this.rehearsalService.getByRehearsalId(this.rehearsalId);
    } catch (e) {
        console.error('Error loading rehearsal details:', e);
    } finally {
      this.isLoading = false;
    }
  }

}
